import { TenantPackageInclude } from '~/tenants/common/package';
import React from 'react';
import MlmFloorplanConfig from '~/tenants/mlm/performable/floorplan/MlmFloorplanConfig';
import { PackageFormNested } from '~/components/performable/PackageForm';
import MlmAerialConfig, { MlmAerialType } from '~/tenants/mlm/performable/aerial/MlmAerialConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import Mlm3dConfig from '~/tenants/mlm/performable/3d/Mlm3dConfig';
import MlmWalkthroughConfig from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughConfig';

export function MlmPackagePhotoInclude({ photos = 34 }: { photos?: number }) {
  var message = `${photos} photos delivered, featuring expert color correction and blue sky replacement.`;

  return (
    <TenantPackageInclude name="Interior & Exterior Real Estate Photos" image="/tenant/mpi/residential/1.jpg">
      {message}
    </TenantPackageInclude>
  );
}

export function MlmPackageFloorplanInclude() {
  return (
    <PackageFormNested performable={MlmFloorplanConfig}>
      <TenantPackageInclude name="2D Floor Plans" image="/tenant/mpi/floorplan/1.jpg">
        Accurate, dimensioned layouts that provide essential spatial context for buyers. One price, regardless of
        property size.
      </TenantPackageInclude>
    </PackageFormNested>
  );
}

export function MlmPackageAerialInclude() {
  return (
    <PackageFormNested performable={MlmAerialConfig}>
      <ZodFieldHidden name="type" value={MlmAerialType.PHOTO} />
      <TenantPackageInclude name="Aerial & Drone Photos" image="/tenant/mpi/aerial/4.jpg">
        Stunning, high-definition aerial views of the property and land, delivered by a certified FAA drone pilot. Includes up to 15 final photos.
      </TenantPackageInclude>
    </PackageFormNested>
  );
}

export function MlmPackage3dInclude() {
  return (
    <PackageFormNested performable={Mlm3dConfig}>
      <TenantPackageInclude name="3D Scan" image="/tenant/mpi/matterport/1.jpg">
        Stunning, high-definition aerial views of the property and land, delivered by a certified FAA drone pilot. Includes up to 15 final photos.
      </TenantPackageInclude>
    </PackageFormNested>
  );
}

export function MlmPackageWalkthroughInclude() {
  return (
    <PackageFormNested performable={MlmWalkthroughConfig}>
      <TenantPackageInclude name="3D Scan" image="/tenant/mpi/matterport/1.jpg">
        Professionally edited video tour optimized for youtube & socials.
      </TenantPackageInclude>
    </PackageFormNested>
  );
}
